import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Flame } from "lucide-react";
import { track } from "@/lib/analytics";

export default function StickyCTA() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 700);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <AnimatePresence>
      {show && (
        <motion.a
          href="#contact"
          data-testid="sticky-floating-contact-cta"
          onClick={() => track("cta_click", { which: "sticky-inquire" })}
          initial={{ opacity: 0, y: 24, scale: 0.9 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: 24, scale: 0.9 }}
          transition={{ duration: 0.35, ease: [0.16, 1, 0.3, 1] }}
          className="fixed bottom-6 right-6 z-40 inline-flex items-center gap-2.5 border border-amber-400/40 bg-ember px-5 py-3.5 font-mono text-[11px] uppercase tracking-[0.25em] text-[#0A0908] shadow-[0_8px_40px_rgba(230,81,0,0.45)] transition-colors duration-300 hover:bg-amber-400"
        >
          <Flame className="size-4" strokeWidth={2} />
          Inquire
        </motion.a>
      )}
    </AnimatePresence>
  );
}
